var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
export var StyledChip = styled(Chip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &:hover {\n        cursor: pointer;\n    }\n"], ["\n    &:hover {\n        cursor: pointer;\n    }\n"])));
var templateObject_1;
